import React from 'react';
import PropTypes from 'prop-types';
import { getOr, omit, isNumber } from 'lodash/fp';
import { Grid, Row, Col, Icon, Input, Button, SelectPicker } from 'rsuite';
// import ExportButton from '../../../containers/reservations/ExportButton';

const statusOptions = [
  { value: 1, label: 'Show' },
  { value: 0, label: 'Hide' }
];

const ROItemSearch = ({
  placeholder,
  searchQuery,
  queryOptions,
  isFetching,
  onChange,
  onSubmit,
  onClear
}) => {
  const handleOnChangeQuery = q => {
    if (q) onChange({ ...searchQuery, q });
    else onChange(omit('q', searchQuery));
  };

  const handleOnChangeStatus = isVisible => {
    if (isNumber(isVisible)) onChange({ ...searchQuery, isVisible });
    else onChange(omit('isVisible', searchQuery));
  };

  return (
    <Grid fluid style={{ padding: 0, marginLeft: 0 }}>
      <Row gutter={8}>
        <Col xs={7}>
          <Input
            value={getOr('', 'q', queryOptions)}
            onChange={handleOnChangeQuery}
            style={{ paddingLeft: 10 }}
            placeholder={placeholder}
            onKeyPress={({ key }) => {
              if (key === 'Enter') onSubmit(queryOptions);
            }}
          />
        </Col>

        <Col xs={3}>
          <SelectPicker
            style={{ width: '100%', marginRight: 10 }}
            value={getOr('', 'isVisible', queryOptions)}
            data={statusOptions}
            appearance="default"
            placeholder="Select Status"
            onChange={handleOnChangeStatus}
          />
        </Col>

        <Col xs={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Button
            color="green"
            style={{ borderBottom: 'none', marginRight: 10 }}
            disabled={isFetching}
            onClick={() => onSubmit(queryOptions)}
          >
            <Icon icon="search" /> Search
          </Button>
          <Button
            style={{ borderBottom: 'none', marginRight: 10 }}
            disabled={isFetching}
            onClick={onClear}
          >
            <Icon icon="refresh" /> Reset
          </Button>
          {/* {!isFetching && (
            <ExportButton
              style={{ marginRight: 10 }}
              type={exportType}
              searchQuery={searchQuery}
            />
          )} */}
        </Col>
      </Row>
    </Grid>
  );
};

const SearchQueryType = PropTypes.shape({
  q: PropTypes.string,
  status: PropTypes.bool
});

ROItemSearch.propTypes = {
  placeholder: PropTypes.string.isRequired,
  searchQuery: SearchQueryType,
  queryOptions: SearchQueryType,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired
};

ROItemSearch.defaultProps = {
  searchQuery: {},
  queryOptions: {}
};

export default ROItemSearch;
